import Businesses from '@/pages/Businesses'

export default {
    path: '/businesses',
    name: 'Businesses',
    component: Businesses
}


// WEBPACK FOOTER //
// ./src/router/businesses.js